/**
 * @generated SignedSource<<bd94794e5606809df9e6582a4994971c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AddExcludeTreeFinishedDispatchConditionInput = {
  clientMutationId?: string | null;
  messageDispatchId: string;
  rootNodeIds: ReadonlyArray<string>;
};
export type useDispatchConditions_AddExcludeTreeFinishedDispatchConditionMutation$variables = {
  input: AddExcludeTreeFinishedDispatchConditionInput;
};
export type useDispatchConditions_AddExcludeTreeFinishedDispatchConditionMutation$data = {
  readonly Admin: {
    readonly Message: {
      readonly addExcludeTreeFinishedDispatchCondition: {
        readonly clientMutationId: string | null;
      } | null;
    };
  };
};
export type useDispatchConditions_AddExcludeTreeFinishedDispatchConditionMutation = {
  response: useDispatchConditions_AddExcludeTreeFinishedDispatchConditionMutation$data;
  variables: useDispatchConditions_AddExcludeTreeFinishedDispatchConditionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MessageAdminMutationSchema",
        "kind": "LinkedField",
        "name": "Message",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "AddExcludeTreeFinishedDispatchConditionPayload",
            "kind": "LinkedField",
            "name": "addExcludeTreeFinishedDispatchCondition",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientMutationId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDispatchConditions_AddExcludeTreeFinishedDispatchConditionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDispatchConditions_AddExcludeTreeFinishedDispatchConditionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1cae040a0456c9b51a332962c429802a",
    "id": null,
    "metadata": {},
    "name": "useDispatchConditions_AddExcludeTreeFinishedDispatchConditionMutation",
    "operationKind": "mutation",
    "text": "mutation useDispatchConditions_AddExcludeTreeFinishedDispatchConditionMutation(\n  $input: AddExcludeTreeFinishedDispatchConditionInput!\n) {\n  Admin {\n    Message {\n      addExcludeTreeFinishedDispatchCondition(input: $input) {\n        clientMutationId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0c4c75c4546de50f1b6b93eb76b2da23";

export default node;
